import React, { useMemo } from "react"
import Card from "../cards/Card"
import type { PlaceCardsProps } from "../../types"
import "./styles/PlaceCards.scss"
import { PLACE_DEFAULT_IMAGE } from "./constants"

const PlaceCards: React.FC<PlaceCardsProps> = ({ places, onClick, onFocus, cardStyle = "list" }) => {
  return (
    <div className={`cards list ${cardStyle}`}>
      {places.map((place) => {
        return (
          <Card
            key={place.id}
            id={place.id}
            title={place.properties.name}
            image={place.properties.image || PLACE_DEFAULT_IMAGE}
            categories={place.properties.categories}
            vibes={place.properties.vibes}
            orientation="horizontal"
            showVibes={true}
            onCardClick={() => onClick(place)}
            onMouseEnter={onFocus ? () => onFocus(place) : undefined}
          />
        )
      })}
    </div>
  )
}

export default React.memo(PlaceCards)
